import React from 'react';
import { Briefcase, Code, FileSpreadsheet, GraduationCap } from 'lucide-react';
import './Portfolio.css';

const portfolioData = [
  {
    icon: <GraduationCap size={28} />,
    title: 'Individualne poduke',
    description: 'Poduka iz matematike i fizike za učenike osnovnih i srednjih škola',
    achievements: ['Shvaćanje gradiva', 'Poboljšanje ocjena', 'Primjeri iz stvarnog života']
  },
  {
    icon: <FileSpreadsheet size={28} />,
    title: 'MS Excel tečaj',
    description: 'Osnovno i napredno korištenje MS Excel-a',
    achievements: ['Održavanje tečajeva u Vašoj firmi ili privatno', 'Od osnovnog do naprednog nivoa']
  },
  {
    icon: <Code size={28} />,
    title: 'Web Development',
    description: 'Edukacija u frontend razvoju i izrada web aplikacija za klijente',
    achievements: ['Izrada modernih web stranica', 'React i JavaScript edukacija', 'Profesionalni projekti za klijente']
  },
  {
    icon: <Briefcase size={28} />,
    title: 'Karijerno savjetovanje',
    description: 'Pomoć u izradi životopisa i prijavi za posao s visokom stopom uspjeha',
    achievements: ['Uspješno se zaposlite', 'Profesionalni CV-evi', 'Profesionalne molbe']
  }
];

const Portfolio = () => {
  return (
    <section id="portfolio" className="portfolio-section">
      <div className="portfolio-container">
        <div className="section-header">
          <span className="section-badge">Iskustvo</span>
          <h2 className="section-title">Radno iskustvo </h2>
          <p className="section-description">
            Pregled stručnih znanja i uspješnih edukacija i projekata s klijentima kroz godine rada.
          </p>
        </div>

        <div className="portfolio-grid">
          {portfolioData.map((item, index) => (
            <div key={index} className="portfolio-card">
              <div className="portfolio-icon">
                {item.icon}
              </div>
              <h3 className="portfolio-title">{item.title}</h3>
              <p className="portfolio-description">{item.description}</p>
              <div className="portfolio-achievements">
                {item.achievements.map((achievement, idx) => (
                  <div key={idx} className="achievement-item">
                    <span className="achievement-bullet"></span>
                    <span>{achievement}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
